export default __webpack_public_path__ + "static/media/soft-drink.db8382a0.svg";